<div class="page-title">
  <div class="title" [innerHTML]="'SubstituteInfo.Second.Title' | translate "></div>
  <div class="sub-title" [innerHTML]="'SubstituteInfo.Second.SubTitle' | translate"></div>
</div>

<app-substitute
  [signatureModel]="user.secondHolder.signatureModel"
  [personalInfo]="user.secondHolder"
  [addressInfo]="user.secondHolder.addressModel"
  [citizenshipInfo]="user.secondHolder.contactModel"
  (userModelChange)="updateUser()"
>
</app-substitute>
